module.exports = __webpack_public_path__ + "img/xingqu.b7a1bfdb.png";